// src/ui/rota-sig.js
//
// v136.8 (the 16 Oct 2026 render audit): opening the Rota tab draws from memory, fetches the week, then drew
// AGAIN even when the fetch brought nothing new: a second rebuild of the whole grid (and of the cover check
// verdict above it, which recomputes from the same shifts) a moment after the first. A repaint that rebuilds
// controls can also throw away a tap in flight (the click-eating class, docs/field-lessons.md). The clock
// screen already solved this with a roster signature (index.html, renderClockScreen, _rosterSig): compare
// before and after, redraw only on a difference. This is the same idea for the rota.
//
// The signature is everything the rota views and the cover verdict read from the shift maps for ONE week and
// ONE store: every key of `shifts` and `shifts2` for that week, with its value. loadShiftsFromDB only ever adds
// or overwrites keys, so equal signatures mean the views would draw exactly the same thing.
//
// Pure: the maps, the week and the store are passed in (index.html declares `shifts` / `shifts2`).

function weekStr(weekStart) {
  if (weekStart instanceof Date) {
    // the local date, as localDateStr does (never toISOString: Dubai is UTC+4)
    return weekStart.getFullYear() + '-' + String(weekStart.getMonth() + 1).padStart(2, '0') + '-' + String(weekStart.getDate()).padStart(2, '0');
  }
  return String(weekStart);
}

function mapSig(map, prefix) {
  if (!map || typeof map !== 'object') return '';
  return Object.keys(map).filter(function (k) { return k.indexOf(prefix) === 0; }).sort().map(function (k) {
    var v;
    try { v = JSON.stringify(map[k]); } catch (e) { v = String(Math.random()); }   // unreadable: never "unchanged"
    return k + '=' + v;
  }).join('|');
}

export function rotaWeekSig(shifts, shifts2, weekStart, store) {
  var prefix = weekStr(weekStart) + '_';
  return String(store) + '#' + prefix + '#' + mapSig(shifts, prefix) + '#' + mapSig(shifts2, prefix);
}
